module.exports = __webpack_public_path__ + "img/design-thinking-dark.b0d332f2.svg";